import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Toasted from 'vue-toasted';
import AuthService from "@/api/auth";
import clientConfigurationService from "@/api/profile_configuration";
import plansService from "@/api/plans";
import usersAdminService from "@/api/Admin/user"
import settingsAdminService from "@/api/Admin/settings"
import axios from 'axios';

Vue.use(Vuex)
Vue.use(Toasted)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    showLoader: false,
    token: "",
    user: {},
    company: {},
  },

  getters:{
    isLoggedIn: state => !!state.token,
    userRole: state => state.user.user_roles != undefined ? state.user.user_roles[0] : "",
    permissions: state => state.user.permisos,
  },

  mutations: {
    SET_SHOW_LOADER: (state, obj) => state.showLoader = obj,
    SET_TOKEN: (state, obj) => state.token = obj,
    SET_USER: (state, obj) => state.user = obj,
    SET_COMPANY: (state, obj) => state.company = obj,
  },

  actions: {
    showMessage(context,payload){
      context.commit('SET_SHOW_LOADER',false);
      switch (payload.action) {
        case 'success':
          Vue.toasted.show(
            payload.message,
            {
              position: "bottom-center",
              duration : 5000,
              iconPack: 'custom-class',
              icon:{
                name: 'icon icon-cot-correcto mr-3',
                after:false
              },
              className:'toast-success'
            }
          )
        break;

        case 'error':
          Vue.toasted.show(
            payload.message,
            {
              iconPack: 'custom-class',
              position: "bottom-center",
              duration : 5000,
              icon:{
                name: 'icon icon-cot-tache mr-3',
                after:false
              },
              className: 'toast-error'
            }

          )
        break;

        case 'warning':
          Vue.toasted.show(
            payload.message,
            {
              iconPack: 'custom-class',
              position: "bottom-center",
              duration : 5000,
              icon:{
                name: 'fas fa-info-circle',
                after:false
              },
              className: 'toast-warning'
            }

          )
        break;

        default:
          break;
      }
    },

    showLoader(context, payload) {
      context.commit('SET_SHOW_LOADER', payload.show)
    },

    updateUser({commit}) {
      return new Promise( (resolve,reject)=> {
        AuthService.userMe().then(
          response => {
            commit('SET_USER',response.data.user);
            commit('SET_COMPANY',response.data.user.team_member);
            resolve(response)
          }
        ).catch(
          error => {
            reject(error)
          }
        )
      })
    },
  },

  modules: {
    client:{
      namespaced:true,
      state:() => ({
        configuration:{},
        planDetails:{},
      }),
      getters:{
        getConfiguration: state => state.configuration,
      },
      mutations: {
        SET_CONFIGURATION: (state, obj) => state.configuration = obj,
        SET_PLAN_DETAILS: (state, obj) => state.planDetails = obj,
      },
      actions:{
        login({commit}, payload) {
          return new Promise( (resolve,reject)=> {
            AuthService.login(payload).then(
              response => {
                if(response.data.email_verified != false){
                  commit('SET_TOKEN', response.data.access_token, {root:true});
                  resolve(response)
                }else{
                  reject({
                    email_verified:false,
                    token:response.data.access_token
                  })
                }
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        signOut(context) {
          return new Promise( (resolve)=> {
            localStorage.clear();
            context.commit('SET_CONFIGURATION',{});
            context.commit('SET_PLAN_DETAILS',{});
            context.commit('SET_TOKEN',"",{root:true})
            context.commit('SET_USER',{},{root:true});
            context.commit('SET_COMPANY',{},{root:true});
            context.commit('SET_SHOW_LOADER',false,{root:true});
            delete axios.defaults.headers.common['Authorization'] ;
            resolve(true);
          })
        },
        register({commit}, payload) {
          return new Promise( (resolve,reject)=> {
            AuthService.register(payload).then(
              response => {
                if(response.data.email_verified != false){
                  commit('SET_TOKEN', response.data.access_token, {root:true});
                  resolve(response)
                }else{
                  reject({
                    email_verified:false,
                    token:response.data.access_token
                  })
                }
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        /* Cuando hace login o registro */
        setData({dispatch,rootState}) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${rootState.token}`;
          return new Promise( (resolve,reject)=> {
            Promise.all([dispatch('updateUser',null,{root:true}),dispatch('updateConfiguration'),dispatch('updatePlanDetails')]).then(
              resolve(true)
            ).catch(
              e=>{
                reject(e)
              }
            );
          })
        },
        updatePlanDetails({commit}) {
          return new Promise( (resolve,reject)=> {
            plansService.getCurrentPlanDetail().then(
              response => {
                commit('SET_PLAN_DETAILS',response.data.data);
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        updateConfiguration({commit}) {
          return new Promise( (resolve,reject)=> {
            clientConfigurationService.getConfiguration().then(
              response => {
                commit('SET_CONFIGURATION',response.data.data);
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        recoverPassword(context,payload) {
          return new Promise( (resolve,reject)=> {
            AuthService.recoverPassword(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        resetPassword(context,payload) {
          return new Promise( (resolve,reject)=> {
            AuthService.resetPassword(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
      }
    },

    admin:{
      namespaced:true,
      state:() => ({
        configuration:{},
      }),
      getters:{
        getConfiguration: state => state.configuration,
      },
      mutations: {
        SET_ADMIN_CONFIGURATION: (state, obj) => state.configuration = obj,
      },
      actions:{
        login({commit}, payload) {
          return new Promise( (resolve,reject)=> {
            AuthService.login(payload).then(
              response => {
                if(response.data.user.user_roles[0] != "Admin"){
                  reject("El usuario no es un tipo admin")
                }else{
                  commit('SET_TOKEN', response.data.access_token, {root:true});
                  resolve(response)
                }

              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        signOut(context) {
          return new Promise( (resolve)=> {
            localStorage.clear();
            context.commit('SET_TOKEN',"",{root:true})
            context.commit('SET_USER',{},{root:true});
            context.commit('SET_COMPANY',{},{root:true});
            context.commit('SET_SHOW_LOADER',false,{root:true});
            delete axios.defaults.headers.common['Authorization'] ;
            resolve(true);
          })
        },
        setDataAdmin({dispatch,rootState}) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${rootState.token}`;
          return new Promise( (resolve,reject)=> {
            Promise.all([dispatch('updateUser',null,{root:true}),dispatch('updateSettingsAdmin')]).then(
              resolve(true)
            ).catch(
              e=>{
                reject(e)
              }
            );
          })
        },
        updateSettingsAdmin({commit}) {
          return new Promise( (resolve,reject)=> {
            settingsAdminService.getGeneralSettings().then(
              response => {
                commit('SET_ADMIN_CONFIGURATION',response.data.data);
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        createUser(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.createNewUser(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        blockUser(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.blockUser(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        addNewMember(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.addMemberToTeam(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        makeUserAdminTeam(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.makeUserAdminTeam(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        deleteUserFromTeam(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.deleteUserFromTeam(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        unblockUser(context,payload) {
          return new Promise( (resolve,reject)=> {
            usersAdminService.unblockUser(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        cancelSuscription(context,payload){
          return new Promise( (resolve,reject)=> {
            usersAdminService.cancelSuscription(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        deleteUser(context,payload){
          return new Promise( (resolve,reject)=> {
            usersAdminService.deleteUser(payload.user_uuid).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        resetPassword(context,payload){
          return new Promise( (resolve,reject)=> {
            usersAdminService.resetPassword(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        },
        updateCompanyInfo(context,payload){
          return new Promise( (resolve,reject)=> {
            usersAdminService.updateCompanyInfo(payload).then(
              response => {
                resolve(response)
              }
            ).catch(
              error => {
                reject(error)
              }
            )
          })
        }
      }
    }
  },

  plugins: [vuexLocal.plugin]
})
